import {axios} from '@/api/axios';
import {EventType} from '@/types/event-type';
import {TICKET_CATEGORY_URLS} from '@/api/urls';
import {formatString} from '@/utils';
import {TicketCategory} from '@/types/ticket-category';
import {CameraToTicketCategoryClass} from '@/types/CameraToTicketCategoryClass';

export const TicketCategoryApi = {
  getList: () => axios.get<TicketCategory[]>(TICKET_CATEGORY_URLS.GET_LIST),
  getListByEvent: (id: string) => axios.get<TicketCategory[]>(formatString(TICKET_CATEGORY_URLS.GET_LIST_BY_EVENT, id)),
  getOne: (categoryId: string) => axios.get<TicketCategory>(formatString(TICKET_CATEGORY_URLS.GET_EVENT, categoryId)),

  save: (data: TicketCategory) => axios.post<EventType>(TICKET_CATEGORY_URLS.SAVE, data),
  edit: (id: string, data: TicketCategory) => axios.put<TicketCategory>(formatString(TICKET_CATEGORY_URLS.EDIT, id), data),
  delete: (id: string) => axios.delete<TicketCategory>(formatString(TICKET_CATEGORY_URLS.EDIT, id)),

  addCameras: (data: CameraToTicketCategoryClass[]) => axios.post<any>(TICKET_CATEGORY_URLS.BULK_SAVE_CAMERAS, {bulk: data}),
  getBulkCameras: (data: any) => axios.post<CameraToTicketCategoryClass[]>(TICKET_CATEGORY_URLS.BULK_GET_CAMERAS, data),
  deleteCameras: (id: string) => axios.delete<any>(formatString(TICKET_CATEGORY_URLS.BULK_DEL_CAMERAS, id))
};
